import { config } from "./Conf";
/**
 * Decorator that randomizes if a joker will be created
 * @param ob Object
 * @param name Function name
 * @param desc Function base items and values
 * @returns Decorated function
 */
export var ballsColorsDecorator = ballsColorsDecoratorFun;
/**
 * Decorator setting the game freeze time after the player's move
 * @param target Target class
 * @returns Decorated constructor
 */
export var gameSpeedDecorator = function (target) {
    var original = target;
    var construct = function (constructor, args) {
        var c = function () {
            this.afterMoveTime = config.fastGame ? 0 : 1000;
            return constructor.apply(this, args);
        };
        c.prototype = constructor.prototype;
        return new c();
    };
    var newConstructor = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        console.log("New: " + original.name + " " + args);
        return construct(original, args);
    };
    newConstructor.prototype = original.prototype;
    return newConstructor;
};
function ballsColorsDecoratorFun(ob, name, desc) {
    var oryg = desc.value;
    desc.value = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var rand = Math.random();
        rand < config.chanceForJoker ? args[0] = true : null;
        return oryg.apply(this, args);
    };
    return desc;
}
